/* global System */
// register component(s) with react habitat

export default { Handwerkersuche: () => System.import('./index') }
